import React from 'react';
import { RecommendationBar } from '../../../components/Shared';
import { MoreOptionsSection } from '../../../components/MoreOptions';
import GenericSection from '../../../components/GenericSection';
import { AdvertisementCiting } from '../../../components/citing/AdvertisementCiting';
import { PubMainTypeEnum } from '../../../types';
import { TV_RADIO_PUBINFO_SECTION_FIELDS } from '../constants/fieldList/tvRadio';
import { TabHeaders } from '../constants';
var TvRadio = function TvRadio() {
  var TV_RADIO_SECTION_TITLE_TEST_ID = 'tv-radio-pub-section-test-id';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(AdvertisementCiting, null), /*#__PURE__*/React.createElement(GenericSection, {
    name: PubMainTypeEnum.PUB_TVR,
    sectionTitle: "TV/Radio publication info",
    fieldList: TV_RADIO_PUBINFO_SECTION_FIELDS,
    "data-test": TV_RADIO_SECTION_TITLE_TEST_ID,
    selectedTab: TabHeaders.TV_RADIO
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default TvRadio;